import React, {useState} from "react";
import InputComponent from "../../../componennts/input";
import './style.css';
import PIB_Section from "./sections/pib_section";
import Address_Section from "./sections/addess_section";
import {Link} from "react-router-dom";
import {ArrowLeft, Check, Download, Icon0Circle, Info, InfoCircleFill} from "react-bootstrap-icons";
import Phones_Section from "./sections/phones_section";
import SocialMedia_Section from "./sections/social_media_section";
import ScrollToTop from "react-scroll-to-top";
import {
    ImageRun,
    Paragraph,
    Table,
    TextRun,
    WidthType,
    HeadingLevel,
    ShadingType,
    TableRow,
    TableCell,
    AlignmentType, TabStopType, TabStopPosition
} from "docx";
import * as docx from "docx";
import {saveAs} from 'file-saver';
import CreditCardInput from "./components/test";
import ForeignActivity_Section from "./sections/foreign_activity_section";
import Info_Component from "./components/info";

function Profile_V5_PersonalPassport() {

    // BEGIN -- DATA FIELD'S
    const [photo, setField_01] = useState();

    function handleChangeFile(e) {
        console.log(e.target.files);
        setField_01(URL.createObjectURL(e.target.files[0]));
    }

    const [countryAndNameDepartment, setField_02] = useState();
    const [dateAccumulation, setField_03] = useState(() => {
        return new Date().toISOString().split('T')[0];
    });

    // section pib
    const [pib, setField_0456] = useState();
    // const [surName, setField_04] = useState();
    // const [firstName, setField_05] = useState();
    // const [lastName, setField_06] = useState();

    const [dateBorn, setField_07] = useState();
    const [locationBorn, setField_08] = useState();

    const [ipn, setField_09] = useState();
    const [ipnForeign, setField_09_2] = useState();

    const [familyStatus, setField_10] = useState();
    const [citizenship, setField_11] = useState();
    const [nationality, setField_12] = useState();
    const [passport, setField_13] = useState();
    const [driverLicense, setField_14] = useState();
    const [foreignPassport, setField_15] = useState();
    const [jobPosition, setField_16] = useState();
    const [education, setField_17] = useState();

    // section address
    let [addressData, setAddressData] = useState([]);

    const handleInsertAddressData = () => {
        setAddressData([...addressData, {
            address: "",
            note: ""
        }]);
    }

    const handleRemoveAddressData = (i) => {
        setAddressData([
            ...addressData.slice(0, i),
            ...addressData.slice(i + 1)
        ]);
    }

    const handleChangeAddressData = (i, e, field) => {
        const values = [...addressData];
        values[i][field] = e.target.value;
        setAddressData(values);
    }

    // section phones
    let [phones, setPhones] = useState([
        {
            phone: "",
            tg_id: "",
            whatsapp: "",
            viber: "",
            tags: ""
        }
    ]);

    const handleChangePhonesValue = (i, e, field) => {
        const values = [...phones];
        values[i][field] = e.target.value;
        setPhones(values);
    }

    const handleInsertPhonesValue = () => {
        setPhones([...phones, {
            phone: "",
            tg_id: "",
            whatsapp: "",
            viber: "",
            tags: ""
        }]);
    }

    const handleRemovePhonesValue = (i) => {
        setPhones([
            ...phones.slice(0, i),
            ...phones.slice(i + 1)
        ]);
    }

    // section E-mail's
    const [emails, setEmails] = useState([]);

    // section conflicts
    const [conflicts, setConflicts] = useState();

    // section Foreign Activity
    const [foreignActivity, setForeignActivity] = useState([
        {
            status: "",

        }
    ]);

    // section summary
    const [summary, setSummary] = useState();
    const [dateConnect, setDateConnect] = useState();

    // END -- DATA FIELD'S

    let requiredSymbol = <small className={'text-danger'}>*</small>;

    let [isChecked, setIsChecked] = useState(true);

    let requiredFiledErrorStyle = {
        //cfe2ff - blue
        background: isChecked ? '#fff' : '#ea9191',
    };

    //
    const [inputValue, setInputValue] = useState('');

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            // alert(`You typed: ${inputValue}`);
            // TODO: insert to array
            setEmails([...emails, inputValue])
            setInputValue('')
        }
    };

    const sections = [
        {
            required: true,
            title: "ПІБ",
            description: "", //Прізвище Імʼя По-батькові
            field: <div className={'d-flex flex-wrap justify-content-end'}>
                <InputComponent
                    type={'text'}
                    name={'pib'}
                    value={pib}
                    onChange={(e) => setField_0456(e.target.value)}
                    placeholder={'Прізвище Імʼя По-батькові'}
                    class={'form-control pp-section-title rounded-0'}
                    style={requiredFiledErrorStyle}
                    // required={true}
                />
                {/*<InputComponent*/}
                {/*    type={'text'}*/}
                {/*    name={'surName'}*/}
                {/*    value={surName}*/}
                {/*    onChange={(e) => setField_04(e.target.value)}*/}
                {/*    placeholder={'Прізвище'}*/}
                {/*    class={'form-control pp-section-title rounded-0 w-25'}*/}
                {/*    style={requiredFiledErrorStyle}*/}
                {/*/>*/}
                {/*<InputComponent*/}
                {/*    type={'text'}*/}
                {/*    name={'firstName'}*/}
                {/*    value={firstName}*/}
                {/*    onChange={(e) => setField_05(e.target.value)}*/}
                {/*    placeholder={'Імʼя'}*/}
                {/*    class={'form-control pp-section-title rounded-0 w-25'}*/}
                {/*    style={requiredFiledErrorStyle}*/}
                {/*/>*/}
                {/*<InputComponent*/}
                {/*    type={'text'}*/}
                {/*    name={'lastName'}*/}
                {/*    value={lastName}*/}
                {/*    onChange={(e) => setField_06(e.target.value)}*/}
                {/*    placeholder={'По-батькові'}*/}
                {/*    class={'form-control pp-section-title rounded-0 w-50'}*/}
                {/*    style={requiredFiledErrorStyle}*/}
                {/*/>*/}
            </div>,
            section: <PIB_Section
                rs={requiredSymbol}
                style={requiredFiledErrorStyle}

                valuePhoto={photo}
                onChangePhoto={(e) => handleChangeFile(e)}

                valueDateBorn={dateBorn}
                onChangeDateBorn={(e) => setField_07(e.target.value)}

                valueLocationBorn={locationBorn}
                onChangeLocationBorn={(e) => setField_08(e.target.value)}

                valueIPN={ipn}
                onChangeIPN={(e) => setField_09(e.target.value)}

                valueFamilyStatus={familyStatus}
                onChangeFamilyStatus={(e) => setField_10(e.target.value)}

                valueCitizenship={citizenship}
                onChangeCitizenship={(e) => setField_11(e.target.value)}

                valueNationality={nationality}
                onChangeNationality={(e) => setField_12(e.target.value)}

                valuePassport={passport}
                onChangePassport={(e) => setField_13(e.target.value)}

                valueDriverLicense={driverLicense}
                onChangeDriverLicense={(e) => setField_14(e.target.value)}

                valueForeignPassport={foreignPassport}
                onChangeForeignPassport={(e) => setField_15(e.target.value)}

                valueJobPosition={jobPosition}
                onChangeJobPosition={(e) => setField_16(e.target.value)}

                valueEducation={education}
                onChangeEducation={(e) => setField_17(e.target.value)}
            />
        },
        {
            required: false,
            title: "Адреса реєстрації/адреса проживання",
            description: "",
            section: <Address_Section
                data={addressData}
                handleInsertData={handleInsertAddressData}
                handleRemoveData={handleRemoveAddressData}
                handleChangeData={handleChangeAddressData}
            />
        },
        {
            required: false,
            title: "Користується абонентськими номерами (зазначати відомості про активність)",
            description: "",
            section: <Phones_Section
                rs={requiredSymbol}
                data={phones}
                handleInsertData={handleInsertPhonesValue}
                handleRemoveData={handleRemovePhonesValue}
                handleChangeData={handleChangePhonesValue}
            />
        },
        {
            required: true,
            title: "Соціальна сторінка",
            description: "",
            section: <SocialMedia_Section/>
        },
        {
            required: false,
            title: "Адреса е-пошти",
            description: "",
            section: <div>
                {/*{emails}*/}
                {/*<br/>*/}
                {/*<input*/}
                {/*    type="mail"*/}
                {/*    value={inputValue}*/}
                {/*    onChange={(e) => setInputValue(e.target.value)}*/}
                {/*    onKeyDown={handleKeyDown}*/}
                {/*    placeholder="Type mail@domain.com and press Enter..."*/}
                {/*/>*/}
                {/*<hr/>*/}
                <textarea name="" id="" cols="60" rows="5" className={'w-100 form-control rounded-top-0'} placeholder={'Не виявлено'} />
            </div>
        },
        {
            required: false,
            title: "Конфлікти та компрометуюча інформація",
            description: "",
            section: <div>
                {conflicts}
                <textarea name="" id="" cols="60" rows="5" className={'w-100 form-control rounded-top-0'} placeholder={'Не виявлено'} />
            </div>
        },
        {
            required: false,
            title: "Перетини державного кордону України",
            description: "Зазначити чи перебуває на даний час на території України, станом на яку дату.\n" +
                "Дата останнього перетину кордону (в’їзд, виїзд), та країна.",
            section: <div>

                <ForeignActivity_Section
                    data={foreignActivity}
                />

            </div>
        },
        {
            required: false,
            title: "Оперативна інформація",
            description: "Необхідно зазначити інформацію яку було встановлено під час аналізу фігуранта",
            section: <div>
                <textarea name="" id="" cols="60" rows="5" className={'w-100 form-control'} placeholder={''} />
            </div>
        },
        {
            required: false,
            title: "Інформація про проходження служби, місця роботи",
            description: "",
            section: <div>TODO</div>
        },
        {
            required: false,
            title: "Висновки (особа, яка вступила в контакт)",
            description: "",
            section: <div>TODO</div>
        },
        {
            required: false,
            title: "Ідентифікуюча інформація",
            description: "",
            section: <div>
                <div>
                    Прикмети (в тому числі особливі):
                    <br/>
                    <InputComponent
                        type={'text'}
                        // name={'pib'}
                        // value={pib}
                        // onChange={(e) => setField_0456(e.target.value)}
                        // placeholder={'Прізвище Імʼя По-батькові'}
                        // class={'form-control pp-section-title rounded-0'}
                        // style={requiredFiledErrorStyle}
                        // required={true}
                    />
                </div>
                <div>
                    <label htmlFor="">
                        <span>Залежності та хронічні хвороби:</span>
                    </label>
                    <br/>
                    <InputComponent
                        type={'text'}
                    />
                </div>
            </div>
        },
        {
            required: false,
            title: "Нерухоме майно",
            description: "Вказати об’єкти нерухомості та підстави володіння.",
            section: <div>
                невстановлено
            </div>
        },
        {
            required: false,
            title: "Транспортні засоби",
            description: "",
            section: <div>
                невідомо
            </div>
        },
        {
            required: false,
            title: "Родинні зв’язки",
            description: "",
            section: <div>TODO</div>
        }
    ];

    function isEmpty(value) {
        return (value == null || (typeof value === "string" && value.trim().length === 0));
    }

    function dataNullTitle(title, subtitle = ''){

        return new docx.Paragraph({
            children: [
                new TextRun({
                    text: title + ": ",
                    italics: true,
                    break: 1,
                }),
                new docx.TextRun({
                    text: subtitle,
                    bold: true,
                }),
            ]
        });
    }

    function rowRecord(title, data, bold = false, isTitle = false, required = false){

        return isTitle
            ?
            new Paragraph({
                heading: HeadingLevel.HEADING_1,
                //     style: "coloredText",
                children: [
                    new TextRun({
                        text: title + ': ' + `${required ? '*' : ''}`,
                        color: "000000",
                        size: 24,
                        bold: true,
                        // break: 1
                    }),
                ],
                shading: {
                    type: ShadingType.SOLID,
                    color: "cfe2ff", // Text color over the background
                    fill: "000000",  // Background color in hex
                },
            })
            :
            isEmpty(data) ? dataNullTitle(title, 'відсутні') : new Paragraph({
                children: [
                    new TextRun({
                        text: title + ": " + `${required ? '* ' : ''}`,
                        // italics: true,
                        bold: bold,
                        break: 1,
                    }),
                    new TextRun({
                        text: data,
                    })
                ]
            });
    }

    function createAddressDataList(addressData: any[], title): Paragraph {

        const texts = addressData.map(value => new docx.TextRun({
            text: value.address + (isEmpty(value.note) ? ' #' : ' - ' + value.note),
            break: 1,
        }));

        texts.unshift(new TextRun({
            text: title + ": ",
            italics: true,
            break: 1,
        }));

        return new Paragraph({
            children: texts
        });
    }

    //TODO: single field show error
    const requiredCheck = () => {

        let fields = [
            countryAndNameDepartment,
            dateAccumulation,
            pib,
            locationBorn,
            familyStatus,
        ];

        if(fields.includes(undefined)){
            setIsChecked(false);
        }
    }

    const downloadDocx = async (documentName = 'profile_passport') => {

        // e.preventDefault();

        //TODO: uncomment
        // requiredCheck();

        // PHOTO
        const blobImage = await fetch(photo ?? '/img.jpeg').then(r => r.blob());

        // Table row PIB
        const tableRow = new TableRow({
            children: [
                new TableCell({
                    children: [
                        new docx.Paragraph({
                            children: [
                                new ImageRun({
                                    data: blobImage,
                                    transformation: {
                                        width: 230,
                                        height: 220,
                                    },
                                }),
                            ]
                        }),
                    ],
                }),
                new TableCell({
                    children: [
                        rowRecord("Дата народження", dateBorn, true, false),
                        rowRecord("Місце народження", locationBorn, true, false, true),
                        rowRecord("ІПН (або іноземний ідентифікатор з поясненням)", ipn, true, false),
                        rowRecord("Сімейний стан", familyStatus, true, false, true, true),
                        rowRecord("Громадянство", citizenship, true, false),
                        rowRecord("Національність", nationality, true, false),
                        rowRecord("Паспорт", passport, true, false),
                        rowRecord("Посвідчення водія", driverLicense, true, false),
                        rowRecord("Паспорт для виїзду за кордон", foreignPassport, true, false),
                        rowRecord("Посада/звання (місце роботи)", jobPosition, true, false),
                        rowRecord("Освіта", education, true, false),
                    ],
                }),
            ],
        });

        const table = new Table({
            columnWidths: [40, 60],
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: [tableRow]
        });

        const _sections =  sections.map((section, i) =>
            rowRecord(section.title, [], true, true, section.required)
        );

        const doc = new docx.Document({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            // 1. Text alignment for the entire block
                            alignment: "center",

                            heading: HeadingLevel.HEADING_1,
                            spacing: { after: 200 },

                            // 2. Background color for the whole paragraph block
                            shading: {
                                type: ShadingType.CLEAR, // Standard solid color fill
                                fill: "cfe2ff",          // Dark grey background hex (Do NOT include '#')
                                color: "000000",
                            },

                            // 3. Child text elements containing the font color
                            children: [
                                new TextRun({
                                    text: "Паспорт особи",
                                    color: "000000",     // White text color hex (Do NOT include '#') F9FAFB
                                    size: 28,            // Font size in half-points (14pt)
                                    bold: true,
                                }),
                            ],
                        }),

                        new Paragraph({
                            // 1. Text alignment for the entire block
                            alignment: AlignmentType.LEFT,
                            // shading: {
                            //     type: ShadingType.CLEAR, // Standard solid color fill
                            //     fill: "cfe2ff",          // Dark grey background hex (Do NOT include '#')
                            //     color: "000000",
                            // },
                            tabStops: [
                                {
                                    type: TabStopType.RIGHT,
                                    position: TabStopPosition.MAX, // Pushes the next text run to the far right margin
                                },
                            ],
                            children: [
                                new TextRun({
                                    text: "Країна, назва підрозділу:*",
                                    // color: "000000",     // White text color hex (Do NOT include '#') F9FAFB
                                    size: 24,            // Font size in half-points (14pt)
                                    bold: true,
                                }),
                                new TextRun({
                                    text: countryAndNameDepartment ?? '-',
                                    size: 24,
                                }),
                                new TextRun({
                                    text: "Дата нарощення:*",
                                    // color: "000000",     // White text color hex (Do NOT include '#') F9FAFB
                                    size: 24,            // Font size in half-points (14pt)
                                    bold: true,
                                    break: 1,
                                    // space: "preserve",
                                }),
                                new TextRun({
                                    text: dateAccumulation ?? '-',
                                    size: 24,
                                }),
                            ],
                        }),

                        new Paragraph({
                            // text: "ПІБ:*",
                            heading: HeadingLevel.HEADING_1,
                            // alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "ПІБ:*",
                                    color: "000000",
                                    size: 24,
                                    bold: true,
                                }),
                                new TextRun({
                                    text: "\t", // This Tab character pushes the next text to the right margin
                                }),
                                new TextRun({
                                    text: pib,
                                    color: "000000",
                                    size: 24,
                                    bold: true,
                                }),
                            ],
                            shading: {
                                type: ShadingType.SOLID,
                                color: "cfe2ff", // Text color over the background
                                fill: "000000",  // Background color in hex
                            },
                        }),

                        table,

                        rowRecord(sections[1].title, [], true, true, sections[1].required),

                        createAddressDataList(addressData, 'Адреси'),

                        // rowRecord(sections[2].title, [], true, true, sections[2].required),

                        // rowRecord(sections[3].title, [], true, true, sections[3].required),
                        //
                        // rowRecord(sections[4].title, [], true, true, sections[4].required),
                        //
                        // rowRecord(sections[5].title, [], true, true, sections[5].required),

                        //
                        // DATA
                        //
                        // rowRecord("ПІБ фігури", `${surName + ' ' + firstName + ' ' + lastName}` + `, ${(dateBorn === "" || dateBorn == null) ? '' : getParsedDate(dateBorn, '.') + ' р.н.'}`, true, false),


                        //
                        // SUMMARY
                        //
                        new Paragraph({
                            //TODO: fix italic style
                            heading: HeadingLevel.HEADING_4,
                            children: [
                                new TextRun({
                                    text: 'Висновок та пропозиції безпосереднього керівника щодо пропозицій вступу в контакт:',
                                    color: "ffffff",
                                    size: 20,
                                    bold: true,
                                }),
                            ],
                            shading: {
                                type: ShadingType.SOLID,
                                color: "de3737", // Text color over the background
                                fill: "000000",  // Background color in hex
                            },
                        }),

                        new docx.Paragraph({
                            children: [
                                new TextRun({
                                    text: summary,
                                }),
                                new TextRun({
                                    text: "Дата вступу в контакт: ",
                                    break: 2,
                                    bold: true
                                }),
                                new TextRun({
                                    text: dateConnect, //`${(dateConnect === "" || dateConnect == null) ? new Date().toLocaleString() : getParsedDate(dateConnect, '.')}`,
                                })
                            ]
                        }),
                    ]
                }
            ],
            styles: {
                paragraphStyles: [
                    {
                        id: "normalText",
                        name: "Normal Text",
                        basedOn: "Normal",
                        run: {},
                    },
                    {
                        id: "coloredText",
                        name: "Colored Text",
                        basedOn: "Normal",
                        run: {
                            color: "6baed6",
                            bold: true
                        },
                    },
                ],
            }
        });

        docx.Packer.toBlob(doc).then(async (blob) => {
            console.log(blob);
            saveAs(blob, `${documentName}.docx`);

            console.log("Document created successfully");
        });

        // if (modeClear) {
        //     _clearFields();
        // }

    }

    return <div id={'Profile_V5_PersonalPassport'} className="d-flex flex-wrap">

        <div className="col-md-3 col-12">

            <div className="d-flex flex-wrap flex-column text-start position-fixed">
                <div className="text-start">
                    <Link to={'/projects'} className={'btn btn-outline-dark'}> <ArrowLeft/> Назад </Link>
                </div>

                <div className="p-3 mt-5 bg-white rounded-4 d-flex flex-column">
                    <small className="text-muted">
                      <InfoCircleFill />  <b className={'text-danger'}>*</b> - обов’язково для заповнення
                    </small>

                    <button onClick={() => downloadDocx(dateAccumulation)} className={'btn btn-outline-dark mt-2'}>
                        <Download /> {dateAccumulation ?? '*'}.docx
                    </button>

                    <button onClick={() => requiredCheck()} className={'btn btn-outline-dark mt-2'}>
                        <Check /> Check Fields
                    </button>

                    {/*TEST*/}
                    <CreditCardInput />
                </div>

            </div>

        </div>

        <div className="col-md-9">
            <div className={'bg-white rounded-4 min-vh-100 p-3 mb-5'}>

                <h1>
                    Паспорт особи
                </h1>

                <div className="border p-2">


                    <div className="d-flex align-items-center justify-content-between">
                        <span>
                            <b>
                                    Країна, назва підрозділу: {requiredSymbol}
                            </b>
                        </span>
                        <InputComponent
                            type={'text'}
                            name={'countryAndNameDepartment'}
                            value={countryAndNameDepartment}
                            onChange={(e) => setField_02(e.target.value)}
                            placeholder={'Україна, ГУР'}
                            class={'form-control rounded-0 border-0 border-bottom w-25'}
                            style={requiredFiledErrorStyle}
                        />
                    </div>

                    <div className="d-flex align-items-center justify-content-between">
                         <span>
                            <b>Дата нарощення: </b> {requiredSymbol}
                         </span>
                        <InputComponent
                            type={'date'}
                            name={'dateAccumulation'}
                            value={dateAccumulation}
                            onChange={(e) => setField_03(e.target.value)}
                            placeholder={''}
                            class={'form-control rounded-0 border-0 border-bottom w-25'}
                            style={requiredFiledErrorStyle}
                        />
                    </div>

                    <br/>

                    {
                        sections.map((section, i) => <div id={'section_' + i} className="text-start p-1">

                            <div className="pp-section-title d-flex align-items-center justify-content-between">

                                <div className="col-md-6 col-12">
                                    <span>
                                       {section.title}: {section.required && requiredSymbol}
                                   </span>
                                </div>

                                <div className="col-md-6 col-12">
                                    {section.field}
                                </div>
                            </div>
                            <i>
                                {section.description}
                            </i>
                            <div>
                                {section.section}
                            </div>
                        </div>)
                    }

                </div>

                <div className={'mt-5'}>

                    <div className={'bg-danger rounded-top p-2 text-start'}>
                        <span className={'text-white'}>
                            Висновок та пропозиції безпосереднього керівника щодо пропозицій вступу в контакт:
                        </span>
                    </div>

                    <textarea name="summary" id="summary" cols="60" rows="4" className={'form-control rounded-bottom-3 rounded-top-0'}
                              value={summary}
                              onChange={(e) => setSummary(e.target.value)}
                              placeholder={'*'}/>

                    <div className={'d-flex align-items-center justify-content-between mt-3'}>
                        <span>
                            <b>
                                Дата вступу в контакт:
                            </b>
                        </span>
                        <InputComponent
                            type={'date'}
                            name={'dateConnect'}
                            value={dateConnect}
                            onChange={(e) => setDateConnect(e.target.value)}
                            placeholder={''}
                            class={'form-control  rounded-3 w-auto'}
                        />
                    </div>

                </div>

            </div>
        </div>

        <ScrollToTop smooth />

    </div>
}

export default Profile_V5_PersonalPassport;
